<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import type { RouterLinkProps as VueRouterLinkProps } from 'vue-router'

import ActionCard, { type ActionCardProps } from './ActionCard.vue'

type ActionCardInherits = Omit<ActionCardProps, 'component' | 'type'>
export type RouterLinkActionCardProps = Omit<VueRouterLinkProps, 'custom'> & ActionCardInherits

const props = defineProps<RouterLinkActionCardProps>()
const attrs = useAttrs()

defineSlots<InstanceType<typeof ActionCard>['$slots']>()

defineOptions({
  inheritAttrs: false,
})

const toBind = computed(() => {
  const { to, replace, activeClass, exactActiveClass, ariaCurrentValue, ...cardProps } = props

  return {
    link: {
      to,
      replace,
      activeClass,
      exactActiveClass,
      ariaCurrentValue,
    },
    card: {
      ...cardProps,
      ...attrs,
    },
  }
})
</script>

<template>
  <RouterLink v-slot="{ href: routerHref, navigate }" v-bind="toBind.link" custom>
    <ActionCard v-bind="toBind.card" component="a" :type="undefined" :href="routerHref" @click="navigate">
      <template v-for="(_, name) in $slots" #[name]>
        <slot :name="name" />
      </template>
    </ActionCard>
  </RouterLink>
</template>
